import React, { useEffect, useState } from "react";
import s from "./PaymentsFilters.module.css";

//Servicio
import gamesService from "../../../../api/games/GamesService";

//assets
import AgencyModal from "../../../Shared/AgencyModal";
import ModalRaffles from "./ModalRaffles";
import { useSelector } from "react-redux";
import { t } from "i18next";

import {
  CircularProgress,
  Grid,
  Modal,
  TextField,
  Select,
  MenuItem,
  Button,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import "dayjs/locale/es";
import "dayjs/locale/pt";
import ReplayIcon from "@mui/icons-material/Replay";
import CloseIcon from "@mui/icons-material/Close";

const PaymentsFilters = ({
  setPage,
  setSearching,
  open,
  setOpen,
  filters,
  setFilters,
  raffleSelected,
  setRaffleSelected,
  gameSelected,
  setGameSelected,
  agencySelected,
  setAgencySelected,
}) => {
  const { activeOrganization } = useSelector((state) => state.gamma);
  const { language } = useSelector((state) => state.local);

  const [games, setGames] = useState([]);
  const [loadingGames, setLoadingGames] = useState(false);
  const [errorGames, setErrorGames] = useState(false);

  const [openRaffle, setOpenRaffle] = useState(false);
  const [openAgency, setOpenAgency] = useState(false);

  const handleSelectGame = (e) => {
    let gameSelected = games.find(
      (item) => item?.modality?.game?.id === e.target.value,
    );
    setGameSelected(gameSelected);
    setRaffleSelected(null);
    setAgencySelected(null);
    setFilters((prev) => ({
      ...prev,
      gameId: e.target.value,
      raffleId: 0,
      agencyId: 0,
    }));
  };

  const getGamesData = () => {
    setLoadingGames(true);
    gamesService
      .getAllGames()
      .then((res) => {
        setGames(res.content);
      })
      .then(() => setLoadingGames(false))
      .catch(() => {
        setErrorGames(true);
        setLoadingGames(false);
      });
  };

  useEffect(() => {
    getGamesData();
  }, []);

  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <Grid container>
        <Grid
          xs={12}
          md={8}
          lg={4.5}
          item
          container
          className={s.boxModal}
          sx={{ bgcolor: "#EEEEEE" }}
        >
          <Grid
            container
            item
            xs={12}
            sx={{ display: "flex", justifyContent: "center" }}
          >
            <Grid item xs={11} className={s.exit}>
              <div className={s.titleModal}>
                <p>{t("payments")}</p>
                <span>{t("filterConfig")}</span>
              </div>
              <CloseIcon
                onClick={() => setOpen(false)}
                className={s.exitIcon}
                sx={{ color: "primary.dark" }}
              />
            </Grid>

            <Grid
              item
              xs={12}
              container
              sx={{ justifyContent: "center", mb: 2 }}
            >
              <Grid item xs={11} className={s.item}>
                <p>{t("couponNumber")}</p>
                <TextField
                  value={filters?.coupon}
                  onChange={(e) => {
                    if (!isNaN(e.target.value) && Number(e.target.value) >= 0) {
                      setFilters({
                        ...filters,
                        coupon: Number(e.target.value) || null,
                      });
                    }
                  }}
                  onKeyPress={(e) => {
                    if (e?.key === "-" || e?.key === "+") {
                      e.preventDefault();
                    }
                  }}
                  sx={{ width: "100%" }}
                />
              </Grid>

              <LocalizationProvider
                dateAdapter={AdapterDayjs}
                adapterLocale={language}
              >
                <Grid item container xs={11} className={s.item}>
                  <Grid item xs={12}>
                    <p>{t("dates")}</p>
                  </Grid>
                  <Grid
                    item
                    container
                    xs={12}
                    sx={{
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Grid item xs={5.7}>
                      <DatePicker
                        value={filters?.dateFrom}
                        maxDate={new Date()}
                        onChange={(newValue) =>
                          setFilters((prev) => ({
                            ...prev,
                            dateFrom: newValue.$d,
                          }))
                        }
                        renderInput={(props) => <TextField {...props} />}
                      />
                    </Grid>
                    <Grid item xs={5.7}>
                      <DatePicker
                        value={filters?.dateTo}
                        minDate={filters?.dateFrom}
                        maxDate={new Date()}
                        onChange={(newValue) =>
                          setFilters((prev) => ({
                            ...prev,
                            dateTo: newValue.$d,
                          }))
                        }
                        renderInput={(props) => <TextField {...props} />}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </LocalizationProvider>

              <Grid item container xs={11} className={s.item}>
                <p>{t("game")}</p>
                {loadingGames ? (
                  <Grid item xs={12}>
                    <CircularProgress size="1.8rem" sx={{ mt: 1 }} />
                  </Grid>
                ) : errorGames ? (
                  <Grid
                    item
                    xs={12}
                    sx={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "end",
                      mt: 1,
                    }}
                  >
                    <p style={{ fontSize: "1.1rem" }}>
                      {t("noGamesDataAvailable")}
                    </p>
                    <ReplayIcon
                      onClick={() => {
                        setErrorGames(false);
                        getGamesData();
                      }}
                      color="primary"
                      sx={{ ml: 1, fontSize: "2rem" }}
                      className={s.icon}
                    />
                  </Grid>
                ) : (
                  <Grid item xs={12}>
                    <Select
                      value={filters?.gameId}
                      onChange={handleSelectGame}
                      sx={{ width: "100%" }}
                    >
                      <MenuItem value={0}>{t("select")}</MenuItem>
                      {games.map((item, i) => {
                        return (
                          <MenuItem key={i} value={item?.modality?.game?.id}>
                            {item?.modality?.game?.name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </Grid>
                )}
              </Grid>

              {filters?.gameId ? (
                <Grid item container xs={11} className={s.item}>
                  <Grid item xs={12}>
                    <p>{t("product")}</p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sx={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                    }}
                  >
                    <TextField
                      value={
                        raffleSelected?.number
                          ? `${t("drawNumber")}: ${raffleSelected.number}`
                          : raffleSelected?.serie
                            ? `${t("serie")}: ${raffleSelected.serie}`
                            : t("selectProduct")
                      }
                      InputProps={{ readOnly: true }}
                      sx={{ width: "75%" }}
                    />
                    <Button
                      sx={{ ml: 3 }}
                      variant="contained"
                      onClick={() => setOpenRaffle(true)}
                    >
                      {t("find")}
                    </Button>
                  </Grid>
                </Grid>
              ) : null}

              <Grid item container xs={11} className={s.item}>
                <Grid item xs={12}>
                  <p>{t("agency")}</p>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sx={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                  }}
                >
                  <TextField
                    value={
                      agencySelected?.id
                        ? `${agencySelected.name} (${agencySelected.number}${agencySelected.subNumber !== null ? ` - ${agencySelected.subNumber}` : ""})`
                        : t("selectAgency")
                    }
                    InputProps={{ readOnly: true }}
                    sx={{ width: "75%" }}
                  />
                  <Button
                    sx={{ ml: 3 }}
                    variant="contained"
                    onClick={() => setOpenAgency(true)}
                  >
                    {t("find")}
                  </Button>
                </Grid>
              </Grid>
            </Grid>

            <Grid
              item
              xs={12}
              sx={{
                mb: 3,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Button
                variant="contained"
                onClick={() => {
                  setPage(1);
                  setSearching((prev) => prev + 1);
                  setOpen(false);
                }}
              >
                {t("apply")}
              </Button>
            </Grid>
          </Grid>
        </Grid>
        {openRaffle ? (
          <ModalRaffles
            open={openRaffle}
            setOpen={setOpenRaffle}
            gameId={filters?.gameId}
            modeId={gameSelected?.modality?.mode?.id}
            setRaffleSelected={setRaffleSelected}
          />
        ) : null}
        {openAgency ? (
          <AgencyModal
            open={openAgency}
            setOpen={setOpenAgency}
            selectAgency={setAgencySelected}
          />
        ) : null}
      </Grid>
    </Modal>
  );
};

export default PaymentsFilters;
